// src/components/AITest.js
import React, { useState } from 'react';
import Modal from 'react-modal';
import { getKeywordsFromAI } from '../api/aiKeywordsApi';
import { sendAIQuery } from '../api/aiApi';
import styles from './AITest.module.css';

Modal.setAppElement('#root');

const AITest = ({ isOpen, onClose }) => {
  const [content, setContent] = useState({
    note: '',
    tags: '',
  });
  const [keywords, setKeywords] = useState([]);
  const [aiInput, setAIInput] = useState('');
  const [aiResponse, setAIResponse] = useState('');
  const [loading, setLoading] = useState(false);
  const [tokenUsage, setTokenUsage] = useState(0);

  const handleAIInputChange = (e) => setAIInput(e.target.value);

  const handleAISubmit = async () => {
    if (!aiInput.trim()) return;
    setLoading(true);
    
    try {
      console.log('Submitting:', aiInput);
      const data = await sendAIQuery(aiInput);
      console.log('Received data:', data);
      
      if (data) {
        setContent(prev => ({
          ...prev,
          note: data.response || data  // ✅ Auto-fills the second text box
        }));
        setTokenUsage(data.token_usage || 0); // ✅ Keep tracking token usage
      }
    } catch (error) {
      console.error('Error in handleAISubmit:', error);
      setContent(prev => ({
        ...prev,
        note: 'Error: Could not fetch AI response'  // Show error in the text box
      }));
    } finally {
      setLoading(false);
    }
  };
  

  const handleUseResponse = () => {
    setContent(prev => ({
      ...prev,
      note: aiResponse
    }));
  };

  const handleChange = (e) => {
    setContent({ ...content, [e.target.name]: e.target.value });
  };

  const handleExtractKeywords = async () => {
    try {
      const extracted = await getKeywordsFromAI(content.note);
      if (!extracted || !extracted.pairs || extracted.pairs.length === 0) {
        console.warn("No keyword pairs extracted.");
        setKeywords([]);
      } else {
        setKeywords(extracted.pairs);
      }
    } catch (error) {
      console.error("Failed to extract keywords:", error);
      setKeywords([]);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className={styles.modal}
      overlayClassName={styles.overlay}
    >
      <div className={styles.content}>
        <h2 className={styles.title}>AI Testing Interface</h2>

        {/* AI Inquiry Section */}
        <div className={styles.section}>
          <h3>AI Inquiry</h3>
          <div className={styles.inputGroup}>
            <input
              type="text"
              value={aiInput}
              onChange={handleAIInputChange}
              placeholder="Enter your AI query..."
              className={styles.input}
            />
            <button 
              onClick={handleAISubmit} 
              className={styles.button}
              disabled={loading}
            >
              {loading ? 'Processing...' : 'Submit Query'}
            </button>
          </div>
          <div className={styles.tokenUsage}>Tokens used: {tokenUsage}</div>  
        </div>

        {/* AI Keywords Section */}
        <div className={styles.section}>
          <h3>AI Keywords Test</h3>
          <div className={styles.formGroup}>
            <label>Enter your text here:</label>
            <textarea
              name="note"
              value={content.note}
              onChange={handleChange}
              className={styles.textarea}
              rows="6"
              placeholder="Enter text to analyze..."
            />
          </div>

          <button onClick={handleExtractKeywords} className={styles.button}>
            Extract Keywords
          </button>

          {keywords.length > 0 && (
            <div className={styles.keywordsDisplay}>
              <h4>Extracted Keyword Pairs:</h4>
              <ul>
                {keywords.map((pair, index) => (
                  <li key={index}>
                    <strong>{pair[0]}</strong>: {pair[1]}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div className={styles.actions}>
          <button onClick={onClose} className={styles.closeButton}>
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AITest;